module.exports = {
  type: 'addons',
  id: 'addons',
  title: {
    de: 'Zusatzprodukte',
    en: 'Addons'
  },
  icon: 'shopping-cart',
  secure: true,
  hidePrices: false,
  category: 'Shop',
}
